<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <div class="meetup-header d-flex align-items-center filter-header">
                <div class="meetup-day filter-subheader">
                  <h3 class="mb-0">
                    {{ typeTitle }}
                  </h3>
                </div>
                <div class="my-auto">
                  <b-card-title class="mb-25">
                    {{ title }}
                  </b-card-title>
                  <b-card-text class="mb-0">
                    {{ description }}
                  </b-card-text>
                </div>
              </div>
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOW') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
          </b-row>
        </div>
        <b-table
          :items="items"
          :fields="fields"
          striped
          responsive
          class="mb-0 resource-listing"
        >
          <template
            v-for="(field, index) in fieldVal"
            v-slot:[field]="row"
          >
            <b-link
              :key="index"
              :href="getLink(row.item.id)"
              target="_blank"
            >
              <div v-if="field === 'cell(custom_fields)' || field === 'custom_fields'">
                <p
                  v-if="getEntry(row.item[fields[index]], field).length > 20"
                  v-b-popover.hover.top="getEntry(row.item[fields[index]], field)"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="custom_field_text"
                  :title="$t('DEBTIA_CUSTOM_FIELDS')"
                >
                  {{ getSubString(getEntry(row.item[fields[index]], field))+'...' }}
                </p>
                <p
                  v-else
                  class="custom_field_text"
                >
                  {{ getSubString(getEntry(row.item[fields[index]], field)) }}
                </p>
              </div>
              <div v-else>{{ getEntry(row.item[fields[index]], field) }}</div>
            </b-link>
          </template>
          <template #cell(show_details)="row">

            <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
            <b-form-checkbox
              v-model="row.detailsShowing"
              @change="row.toggleDetails"
            >
              {{ row.detailsShowing ? 'Hide' : 'Show' }}
            </b-form-checkbox>
          </template>

          <!-- full detail on click -->
          <template #row-details="row">
            <b-card>
              <b-row class="mb-2">
                <b-col
                  v-for="(data, index) in hiddenColumns"
                  :key="index"
                  md="4"
                  class="mb-1"
                >
                  <strong>{{ getLabel(data) }} : </strong>{{ row.item[data] ? getEntry(row.item[data], data) : 'N/A' }}
                </b-col>
              </b-row>

              <b-button
                size="sm"
                variant="outline-secondary"
                @click="row.toggleDetails"
              >
                {{ $t('DEBTIA_HIDE_DETAILS') }}
              </b-button>
            </b-card>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOW') }} {{ from }} {{ $t('DEBTIA_TO') }} {{ to }} {{ $t('DEBTIA_OF') }} {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BCardText, BOverlay, BTable, BRow, BCol, BButton, BPagination, BFormCheckbox, BLink, VBPopover,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import i18n from '@/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
// import AddModal from './AddModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BButton,
    BPagination,
    // AddModal,
    BLink,
    BFormCheckbox,
    BCardTitle,
    BCardText,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      loader: false,
      perPage: 10,
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      hiddenColumns: [],
      fields: [],
      fieldVal: [],
      /* eslint-disable global-require */
      items: [],
      type: null,
      description: '',
      title: '',
      typeTitle: '',
      perPageOptions: [10, 25, 50, 100],
      caseStatuses: [
        {
          value: 0,
          label: 'DEBTIA_PENDING',
        },
        {
          value: 1,
          label: 'DEBTIA_ACCEPTED',
        },
        {
          value: 2,
          label: 'DEBTIA_DECLINED',
        },
        {
          value: 3,
          label: 'DEBTIA_TERMINATED',
        },
        {
          value: 4,
          label: 'DEBTIA_PAUSED',
        },
      ],
      loginPermission: [
        {
          value: 0,
          label: 'DEBTIA_NOT_ALLOWED',
        },
        {
          value: 1,
          label: 'DEBTIA_ALLOWED',
        },
      ],
      vatExempted: [
        {
          value: 0,
          label: 'DEBTIA_NO',
        },
        {
          value: 1,
          label: 'DEBTIA_YES',
        },
      ],
    }
  },
  // computed: {
  // },
  watch: {
    searchQuery: {
      handler() {
        this.getFilterList()
      },
    },
    currentPage: {
      handler() {
        this.getFilterList()
      },
    },
    perPage: {
      handler() {
        this.getFilterList()
      },
    },
  },
  created() {
    this.getFilterList()
  },
  methods: {
    getSubString(value) {
      return value.slice(0, 20)
    },
    getEntry(data, label) {
      let response = ''
      if (label === 'cell(status)' || label === 'status') {
        const item = this.caseStatuses.filter(element => element.value === data)
        response = i18n.t(item[0].label)
      } else if (label === 'cell(client_vat_exemption)' || label === 'client_vat_exemption') {
        const item = this.vatExempted.filter(element => element.value === data)
        response = i18n.t(item[0].label)
      } else if ((label === 'cell(client_login_permission)' || label === 'client_login_permission')
      || (label === 'cell(debtor_login_permission)' || label === 'debtor_login_permission')) {
        const item = this.loginPermission.filter(element => element.value === data)
        response = i18n.t(item[0].label)
      } else {
        response = typeof data === 'object' ? this.getStringified(data) : data
      }
      return response
    },
    getStringified(data) {
      let response = ''
      if (data.length === 0) {
        response = 'No Data'
      } else {
        data.forEach(element => {
          response += response === '' ? element : `, ${element}`
        })
      }
      return response
    },
    getTypeText(type) {
      if (type === 'case') {
        this.typeTitle = i18n.t('DEBTIA_CASES')
      } else if (type === 'debtor') {
        this.typeTitle = i18n.t('DEBTIA_DEBTORS')
      } else {
        this.typeTitle = i18n.t('DEBTIA_CLIENTS')
      }
    },
    getLink(id) {
      let link = null
      if (this.type === 'case') {
        link = `/cases/details/v2/${id}`
        this.typeTitle = i18n.t('DEBTIA_CASES')
      } else if (this.type === 'debtor') {
        link = `/debtors/view/${id}`
        this.typeTitle = i18n.t('DEBTIA_DEBTORS')
      } else {
        link = `/clients/view/${id}`
        this.typeTitle = i18n.t('DEBTIA_CLIENTS')
      }
      return link
    },
    getLabel(text) {
      return text.replace(/_/g, ' ')
    },
    getDescription(description) {
      return description.length > 50 ? `${description.slice(0, 50)}...` : description
    },
    async getFilterList() {
      try {
        this.loader = true
        const filterId = Number(this.$route.params.id)
        const allFilters = await axios.get(`/get-filter-list-data?filter_list_id=${filterId}`, {
          params: {
            perPage: this.perPage,
            q: this.searchQuery,
            page: this.currentPage,
          },
        })
        if (allFilters.status) {
          this.getTypeText(allFilters.data.data.type)
          this.title = allFilters.data.data.title
          this.description = allFilters.data.data.description
          this.fieldVal = []
          this.fields = []
          this.hiddenColumns = []
          const allcolumns = allFilters.data.data.columns
          this.type = allFilters.data.data.type
          let count = 1
          allcolumns.forEach(column => {
            if (count < 5) this.fields.push(column)
            if (count < 5) this.fieldVal.push(`cell(${column})`)
            if (count >= 5) this.hiddenColumns.push(column)
            count += 1
          })
          this.fields.push('show_details')
          if (allcolumns.length < 5) this.sliceColumn(allcolumns.length)
          this.items = allFilters.data.data.filter_list_data.data
          this.totalPages = allFilters.data.data.filter_list_data.total
          this.from = allFilters.data.data.filter_list_data.from
          this.to = allFilters.data.data.filter_list_data.to
          this.currentPage = allFilters.data.data.filter_list_data.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    sliceColumn(length) {
      this.fields.splice(length)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.filterDescription {
  display: flex !important;
}

.filter-header {
  margin-bottom: 2rem;
}

.filter-subheader {
  border-right: 1px solid #d8d6de;
  padding-right: 1.3rem;
  margin-right: 1.3rem;
}

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}

.custom_field_text {
  margin-bottom: 0rem !important;
}
</style>
